import { colors } from '@constants/colors';
import { SwiperScreenSizes } from '@interfaces/index';
import { IStyles } from '@interfaces/styles';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = (): IStyles => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const { backgroundColorHover } = appTheme.submitButton;

  return {
    createRoot: {
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        width: '100%',
      },
    },
    createCard: {
      position: 'relative',
      boxShadow: 'none',
    },
    createContent: {
      cursor: 'pointer',
      borderRadius: '16px',
      height: '116px',
      backgroundColor: colors.grey_light,
      border: `2px solid ${colors.grey_100}`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '10px',
      textAlign: 'center',
      alignItems: 'center',
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        width: 'calc(100% - 32px)',
        aspectRatio: '1/1',
        height: 'calc(100% - 32px)',
      },
      '&:hover': {
        border: `2px solid ${backgroundColorHover}`,
      },
      '&:last-child': {
        padding: '12px',
      },
    },
    createIcon: {
      stroke: colors.black,
      width: '30px',
      height: '30px',
    },
    createText: {
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 500,
    },
  };
};
